function sortJsonValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(sortJsonValue);
  }
  if (value && typeof value === 'object') {
    const record = value as Record<string, unknown>;
    return Object.keys(record)
      .sort()
      .reduce<Record<string, unknown>>((sorted, key) => {
        sorted[key] = sortJsonValue(record[key]);
        return sorted;
      }, {});
  }
  return value;
}

/** JSON signature with sorted object keys for stable content comparison. */
export function stableJsonSignature(value: unknown): string {
  return JSON.stringify(sortJsonValue(value));
}
